/* TODO:
  For Future Updates:
    Permissions - user can only update a singular Sport
    Archiving - Past Seasons can be set aside and viewed later
    Sorting
*/

// react imports
import React, { Component } from 'react';
import ReactModal from 'react-modal';

// prop types
import PropTypes from 'prop-types';

// react redux connect
import { connect } from 'react-redux';
import styled from 'styled-components';

// JS moment
import moment from 'moment';

// icons
import BackIcon from '@material-ui/icons/ArrowBack';
import HomeIcon from '@material-ui/icons/Home';

// material ui pickers
import MomentUtils from '@date-io/moment';

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';


// material ui core
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Checkbox,
  CircularProgress,
  Button,
  IconButton,
  Grid,
  Tabs,
  Tab,
  TextField,
  Select,
  MenuItem
} from '@material-ui/core';

// homemade component imports
import {
  ItemGrid,
  UploadButton,
} from "../../components";

import { Redirect } from "react-router-dom";

// reducer imports
import { loadSeason, createNewSeason, editSeason, deleteSeason } from './reducer/actions';

// modal styles - header
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
` // body
const ModalContent = styled.div`
  padding: 20px 20px;
  line-height: 50px;
  overflow-y: hidden;
  overflow-x: hidden;
` // footer

// styles for the Team Modal window
const teamModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '555px',
    bottom: 'auto',
    minHeight: '10rem',
  }
};

// theme style
const styles = theme => ({
  /* main table */
  table: {
    width: '100%',
    backgroundColor: 'white',
  },
  /* individual rows */
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  /* big button for divisions */
  button: {
    background: '#3399ff',
    color: 'white',
    width: 120,
    borderRadius: 5,
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 10,
    marginTop: 5,
  },
  /* small button for top bars */
  smallButton: {
    background: '#3399ff',
    color: 'white',
    borderRadius: 5,
    fontSize: 8,
    fontWeight: 'bold',
    marginTop: 5,
    marginLeft: 10,
  },
  /* grid container style */
  theGrid: {
    paddingTop: 5,
    alignItems: 'center',
    alignContent: 'center',
  },
  /* name of Sport style */
  sportName: {
    fontSize: 28,
    fontFamily: 'Source Sans Pro',
  },
  /* text for headers and nav bars */
  headerText: {
    fontSize: 21,
    fontFamily: 'Source Sans Pro',
    fontWeight: 'bold',
    paddingTop: 5,
    paddingBottom: 10,
  },
  /* Modal Text style */
  modalText: {
    fontSize: 20,
    fontFamily: 'Source Sans Pro',
  },
});

// sets the time as the current date at noon
// used to reset the value of Schedule
function setDate() {
  let date = new Date();
  date.setHours(12);
  date.setMinutes(0);
  return date;
}

// My first girlfriend turned into the moon.
// That's rough, buddy.

// start of SeasonList
class SeasonList extends Component {
  // Constructor - set up State
  constructor (props) {
    super(props);
    // state setup
    this.state = {
      title: '', /* Name of Season */
      sport: {}, /* Sport that is currently being edited */
      sportInfo: {}, /* Parsed information about currently edited Sport */
      sports: [], /* Sports array - contains names of Sports that are played */
      rosters: [], /* Rosters array - contains all the Players in a Season */
      schedules: [], /* Schedules array - contains all the Games in a Season */
      sportName: '', /* Name of the currently edited Sport */
      sportDivision: '', /* Division of currently edited Sport */
      sportBg: '', /* background image uri for the Sports modal for a team */
      seasonTabs: 0, /* current tab of Winter/Fall/Spring */
      teamTabs: 0, /* current tab of Roster/Schedule/Edit */
      editingTeam: false, /* if True, editing a singular Team and Division */
      isEditing: false, /* whether or not a Team is currently being Edited */
      hash: null, /* the Hash of the currently added/edited Team */
      seasonModal: false, /* show the Add Season modal */
      seasonName: '', /* the name of the currently added Season */
      customFirst: '', /* name of a Custom named division */
      customSecond: '', /* name of a custom named division */
    };
  }

  // load in Season
  componentWillMount() {
    this.props.loadSeason();
  }

  // used to reload Season after new data added
  componentDidMount() {
    this.props.loadSeason();
  }

  // On successful Edit/Create, close the Modal
  _onSuccess () {
    this.setState({ showModal: false, seasonModal: false });
  }

  // Close the modal and log an error if something went wrong
  _onError (error) {
    this.setState({ showModal: false, seasonModal: false });
    console.log(error);
  }

  // Called upon pressing the Edit button
  // sets the Sports, Rosters, and Schedules, then reloads the page
  _onEditSeason() {
    const { allSeason } = this.props;
    const curSeason = allSeason[this.state.seasonTabs];
    this.props.editSeason(curSeason.id, {
        title: curSeason.title,
        sports: this.state.sports,
        rosters: this.state.rosters,
        schedules: this.state.schedules,
        id: curSeason.id
    }, this._onSuccess.bind(this), this._onError.bind(this));
    this.componentDidMount();
  }

  // delete a Season
  _onDeleteSeason (id) {
    this.props.deleteSeason(id, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // change the Fall/Winter/Spring tabs
  changeSeasonTab = (event, value) => {
    this.setState({seasonTabs: value});
  };

  // change the Schedule/Roster/Details tabs
  changeTeamTab = (event, value) => {
    this.setState({teamTabs: value});
  };

  // Hash Generation - simple Hash creation that allows
  // identification of players and games for each league
  hashGeneration(str) {
    var hash = require('object-hash');
    const h = hash(str);
    return h.toString();
  }

  // depreciated, but hold for possible future use
  retrieveUserInfo() {
    const { user = {} } = this.props;
    let value = ' ,taht od uoy tel t\'nac i';
    value = value.split('');
    value = value.reverse();
    value = value.join('');
    let name = user.name;
    if (name.indexOf(' ') !== -1) {
      name = name.slice(0, name.indexOf(' '));
    }
    name = value + name;
    name = name.toUpperCase();
    name += '.';
    return name;
  }

  // organize seasons in order Fall, Winter, Spring
  // (even if one of those is not present)
  organize() {
    const { allSeason } = this.props;
    // check that Season is an Object
    if (typeof allSeason !== 'object') {
      return;
    }
    // and long enough to warrant checking further
    if (allSeason.length < 2) {
      return;
    }
    // seasons - which Seasons are currently in allSeason
    var seasons = [null, null, null];
    // ids - the id of each season
    var ids = [];
    // sort
    for (var s = 0; s < allSeason.length; ++s) {
      if (allSeason[s].title === 'Fall') {
        seasons[0] = allSeason[s];
      }
      else if (allSeason[s].title === 'Winter') {
        seasons[1] = allSeason[s];
      }
      else if (allSeason[s].title === 'Spring') {
        seasons[2] = allSeason[s];
      }
      ids.push(allSeason[s].id);
    }
    // remove any Null seasons
    for (var p = 0; p < 3; ++p) {
      if (seasons[p] === null) {
        seasons.splice(p, 1);
      }
    }
    // set season id and switch them around in the backend
    for (var i = 0; i < seasons.length; ++i) {
      seasons[i].id = ids[i];
      this._onSwitchSeason(seasons[i]);
    }
    // reload
    this.componentDidMount();
  }

  // called when any Division button is clicked
  // sets state and allows editing of that Sport/Division
  onDivisionButtonClick(sportName, division) {
    const { allSeason } = this.props;
    // seasonTabs will allow access to the proper Season
    const season = allSeason[this.state.seasonTabs];
    let name = sportName;
    // retrieve name of sport from object if necessary
    if (typeof name !== 'string') {
      name = name.value;
    }
    // division contains the hash code to retrieve schedules and rosters
    this.setState({
      sports: season.sports,
      rosters: season.rosters || [],
      schedules: season.schedules || [],
      editingTeam: true,
      sportName: name,
      sportDivision: division.value,
      hash: division.key,
      teamTabs: 0
    });
  }

  // Called by organize if seasons are out of order
  _onSwitchSeason (s) {
    this.props.editSeason(s.id, {
        title: s.title,
        sports: s.sports || [],
        rosters: s.rosters || [],
        schedules: s.schedules || [],
        id: s.id
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // Called upon pressing Create button
  _onCreateNewSeason (str) {
    this.props.createNewSeason({
        title: str,
    }, this._onSuccess.bind(this), this._onError.bind(this));
    setTimeout(()=>this.organize(), 1500);
    this.setState({seasonName: ''});
  }

  // Open Modal and Set State
  // is only called for creating a new Team, Schedule, or Roster
  _ShowAddModal () {
    this.setState({
      isEditing: false,
      showModal: true,
      sportName: '',
      roster: {key: '', name: '', number: '',
        height: '', weight: '', grade: '', position: ''},
      schedule: { key: '', date: setDate(), win: '',
        homeAway: '', homeTeamScore: '',
        opponentTeamName: '', opponentTeamScore: '', tba: false},
    })
  }

  // called for editing an existing Team
  _ShowEditTeamModal(sport) {
    // create an object to more accessibly hold the sport info
    var sportInfo = {varsity: false, jv: false, freshman: false, custom: false};
    // retrieve name
    var name = sport[0];
    // if name is an object, just get the name and not the url
    if (typeof name === 'object') {
      name = name.value;
    }

    // map through the divisions
    for (var d = 1; d < sport.length; ++d) {
      let division = sport[d];
      // and switch on any existing divisions
      switch(division.value) {
        case 'Varsity':
          sportInfo.varsity = true;
          break;
        case 'JV':
          sportInfo.jv = true;
          break;
        case 'Freshman':
          sportInfo.freshman = true;
          break;
        default:
          sportInfo.custom = true;
          if (this.state.customFirst === '') {
            this.setState({customFirst: division.value});
          }
          else if (this.state.customSecond === '') {
            this.setState({customSecond: division.value});
          }
          break;
      }
    }

    const { allSeason } = this.props;
    // seasonTabs will allow access to the proper Season
    const season = allSeason[this.state.seasonTabs];

    this.setState({
      showModal: true,
      isEditing: true,
      sport: sport,
      sportInfo: sportInfo,
      sportName: name,
      sports: season.sports,
      rosters: season.rosters || [],
      schedules: season.schedules || [],
    })
  }

  // Close Modal and Set State
  _onCloseModal () {
    this.setState({ showModal: false });
  }


  /*** SPORTS AND TEAMS FUNCTIONS ***/

  // creates a new Team and its user-picked Divisions
  addToSports() {
    // get the current season
    const { allSeason } = this.props;
    const curSeason = allSeason[this.state.seasonTabs];
    // create a new array for the current sport
    let newSport = [];
    // retrieve the name of the sport
    let sportName = this.state.sportName;
    // add the name of the sport to the array first
    newSport.push(sportName);
    // add a Varsity division and Hash if it was selected
    if (this.state.checkVarsity === true) {
      newSport.push({key: this.hashGeneration(sportName + 'Varsity'),
        value: 'Varsity'});
    }
    // add a JV division
    if (this.state.checkJV === true) {
      newSport.push({key: this.hashGeneration(sportName + 'JV'),
        value: 'JV'});
    }
    // add Freshman division
    if (this.state.checkFresh === true) {
      newSport.push({key: this.hashGeneration(sportName + 'Freshman'),
        value: 'Freshman'});
    }
    // add one or two Custom Divisions
    if (this.state.checkCustom === true) {
      // Custom #1
      if (this.state.customFirst !== '' && this.state.customFirst) {
        newSport.push({
          key: this.hashGeneration(sportName + this.state.customFirst),
          value: this.state.customFirst});
      }
      // Custom #2
      if (this.state.customSecond !== '' && this.state.customSecond) {
        newSport.push({
          key: this.hashGeneration(sportName + this.state.customSecond),
          value: this.state.customSecond});
      }
    }
    // set Current Sports as an empty array
    let curSports = [];
    // or if other sports have been added, retrieve them
    if (curSeason.hasOwnProperty('sports')) {
      curSports = curSeason.sports;
    }
    // add new sport to the other sports
    curSports.push(newSport);
    // reset the Add Team modal
    this.setState({sportName: '',
      checkVarsity: false, checkJV: false, checkFresh: false,
      checkCustom: false, customFirst: '', customSecond: ''});
    // update Season in Firebase Database
    this.props.editSeason(curSeason.id, {
      title: curSeason.title,
      sports: curSports,
      rosters: curSeason.rosters || [],
      schedules: curSeason.schedules || [],
    }, this._onSuccess.bind(this), this._onError.bind(this));
    // reload so the new Sport shows up
    this.componentDidMount();
  }

  // Print Sports - prints Fall, Winter, or Spring sports
  // depending on the current Tab
  printSports(season) {
    // if Season does not yet exist, print a brief explanation
    if (!season || typeof season !== 'object') {
      return (
        <Grid container>
          <ItemGrid xs={3} />
          <ItemGrid xs={5}>
            <div>
              This is the Season section, where you can add school athletics.
            </div>
            <div>
              Click the Add Season button to get started.
            </div>
            <div>
              If your school does not have any sports teams, simply leave this section as is.
            </div>
          </ItemGrid>
        </Grid>
      );
    }
    // if no sports have been added, return immediately
    if (!season.hasOwnProperty('sports')) {
      return (
        <TableRow>
          <TableCell>
            No sports have been added!
          </TableCell>
        </TableRow>
      );
    }
    // get class styles from props
    const { classes } = this.props;
    // get the season's sports
    const sports = season.sports;
    // otherwise, map the sport name to the title and the divisions to buttons
    return sports.map((sport) => (
      <TableRow className={classes.row}>
        <Grid container className={classes.theGrid}>
          {/* print the name of the sport */}
          <ItemGrid xs={3}>
            <div className={classes.sportName}>
              { typeof sport[0] === 'string' ? sport[0] : sport[0].value }
            </div>
          </ItemGrid>
          {/* print all the divisions as buttons */}
          <ItemGrid xs={6}>
            {
              sport.slice(1).map((division) =>
              <Button className={classes.button}
                onClick={()=>this.onDivisionButtonClick(sport[0], division)}>
                { division.value }
              </Button>
              )
            }
          </ItemGrid>
          {/* Edit Team button for each Team */}
          <ItemGrid xs={2}>
            <Button className={classes.smallButton}
              onClick={() => this._ShowEditTeamModal(sport)}>
              EDIT TEAM
            </Button>
          </ItemGrid>
        </Grid>
      </TableRow>
    ));
  }

  // the modal that enables adding a new Team to a Season
  addTeamModal() {
    // import styles
    const { classes } = this.props;
    // the actual modal
    return (
      this.state.showModal && !this.state.isEditing &&
      <ReactModal isOpen={this.state.showModal && !this.state.isEditing}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={'Add Team'}
        ariaHideApp={false}
        style={teamModalStyles}
        overflow={'auto'}
      > {/* end of React Modal opening tag */}
        {/* Add Team header, Edit Team modal is elsewhere */}
        <ModalHeader>
          Add Team
        </ModalHeader>
        <ModalContent>
          <Grid container>
            {/* Header for Sport name input */}
            <ItemGrid xs={5}>
              <span className={classes.modalText}>
                Sport Name:
              </span>
            </ItemGrid>
            {/* Text Field for Sport name input */}
            <ItemGrid xs={5}>
              <TextField
                id='sports'
                label=''
                value={this.state.sportName}
                onChange={(e)=>this.setState({sportName: e.target.value})}
              />
            </ItemGrid>
            <ItemGrid xs={2} />
            {/* Checkbox section */}
            <ItemGrid xs={5} >
              <span className={classes.modalText}>
                Divisions:
              </span>
            </ItemGrid>
            {/* Varsity header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                Varsity
              </span>
            </ItemGrid>
            {/* Varsity checkbox */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.checkVarsity}
                onChange={() => this.checked('varsity')}
                value="checked"
                color="primary"
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* JV header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                JV
              </span>
            </ItemGrid>
            {/* JV checkbox */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.checkJV}
                onChange={() => this.checked('jv')}
                value="checked"
                color="primary"
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Freshman header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                Freshman
              </span>
            </ItemGrid>
            {/* Freshman checbox */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.checkFresh}
                onChange={()=> this.checked('freshman')}
                value="checked"
                color="primary"
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Custom header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                Custom
              </span>
            </ItemGrid>
            {/* Custom checkbox - if clicked, will allow input of Custom Divisions */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.checkCustom}
                onChange={()=> this.checked('custom')}
                value="checked"
                color="primary"
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Input for first Custom Division */}
            <ItemGrid xs={7}>
              <TextField
                id='sports'
                label='Custom Division #1'
                value={this.state.customFirst}
                onChange={(e)=>this.setState({customFirst: e.target.value})}
                disabled={!this.state.checkCustom}
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Input for second Custom Division */}
            <ItemGrid xs={7}>
              <TextField
                id='sports'
                label='Custom Division #2'
                value={this.state.customSecond}
                onChange={(e)=>this.setState({customSecond: e.target.value})}
                disabled={!this.state.checkCustom}
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
            <ItemGrid xs={2} />
            {/* Add to Sports button */}
            <ItemGrid xs={4}>
              <Button className={classes.button}
                onClick={(e) => {this.addToSports(this.state.sportName,
                this.state.checkVarsity, this.state.checkJV,
                this.state.checkFresh)} }
              >
                {'Add'}
              </Button>
            </ItemGrid>
            {/* Close button */}
            <ItemGrid xs={4}>
              <Button className={classes.button}
                onClick={this._onCloseModal.bind(this) }
              >
                {'Close'}
              </Button>
            </ItemGrid>
          </Grid>
        </ModalContent>
      </ReactModal>
    );
  }

  // when something in the Add Team modal is Checked,
  // change state accordingly
  checked(str) {
    if (str === 'varsity') {
      this.setState({checkVarsity: !this.state.checkVarsity});
    }
    else if (str === 'jv') {
      this.setState({checkJV: !this.state.checkJV});
    }
    else if (str === 'freshman') {
      this.setState({checkFresh: !this.state.checkFresh});
    }
    else if (str === 'custom') {
      this.setState({checkCustom: !this.state.checkCustom});
    }
  }

  // edit the name of a team
  editTeamModal() {
    // import styles
    const { classes } = this.props;
    // the actual modal
    return (
      this.state.showModal &&
      <ReactModal isOpen={this.state.showModal && this.state.isEditing}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={'Edit Team'}
        ariaHideApp={false}
        style={teamModalStyles}
        overflow={'auto'}
      > {/* end of React Modal opening tag */}
        <ModalHeader>
          Edit Team
        </ModalHeader>
        <ModalContent>
          <Grid container>
            {/* Header for Sport name input */}
            <ItemGrid xs={5}>
              <span className={classes.modalText}>
                Sport Name:
              </span>
            </ItemGrid>
            {/* Text Field for Sport name input */}
            <ItemGrid xs={5}>
              <TextField
                id='sports'
                label=''
                value={this.state.sportName}
                onChange={(e)=>this.setState({sportName: e.target.value})}
                inputProps={{maxLength: 24}}
              />
            </ItemGrid>
            <ItemGrid xs={2} />
            {/* Checkbox section */}
            <ItemGrid xs={5} >
              <span className={classes.modalText}>
                Divisions:
              </span>
            </ItemGrid>
            {/* Varsity header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                Varsity
              </span>
            </ItemGrid>
            {/* Varsity checkbox
                If a sport has already been added, disable the checkbox
              */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.sportInfo.varsity || this.state.checkVarsity}
                onChange={() => this.checked('varsity')}
                value="checked"
                color="primary"
                disabled={this.state.sportInfo.varsity}
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* JV header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                JV
              </span>
            </ItemGrid>
            {/* JV checkbox */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.sportInfo.jv || this.state.checkJV}
                onChange={() => this.checked('jv')}
                value="checked"
                color="primary"
                disabled={this.state.sportInfo.jv}
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Freshman header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                Freshman
              </span>
            </ItemGrid>
            {/* Freshman checbox */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.sportInfo.freshman || this.state.checkFresh}
                onChange={()=> this.checked('freshman')}
                value="checked"
                color="primary"
                disabled={this.state.sportInfo.freshman}
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Custom header */}
            <ItemGrid xs={4} >
              <span className={classes.modalText}>
                Custom
              </span>
            </ItemGrid>
            {/* Custom checkbox - if clicked, will allow input of Custom Divisions */}
            <ItemGrid xs={3} >
              <Checkbox
                checked={this.state.sportInfo.custom || this.state.checkCustom}
                onChange={()=> this.checked('custom')}
                value="checked"
                color="primary"
                disabled={this.state.sportInfo.custom}
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Input for first Custom Division */}
            <ItemGrid xs={7}>
              <TextField
                id='sports'
                label='Custom Division #1'
                value={this.state.customFirst}
                onChange={(e)=>this.setState({customFirst: e.target.value})}
                disabled={!this.state.checkCustom}
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
            <ItemGrid xs={5} />
            {/* Input for second Custom Division */}
            <ItemGrid xs={7}>
              <TextField
                id='sports'
                label='Custom Division #2'
                value={this.state.customSecond}
                onChange={(e)=>this.setState({customSecond: e.target.value})}
                disabled={!this.state.checkCustom}
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
            <ItemGrid xs={2} />
            {/* Edit Sport button */}
            <ItemGrid xs={4}>
              <Button className={classes.button}
                onClick={() => {this.editSport()} }
              >
                {'Edit'}
              </Button>
            </ItemGrid>
            {/* Close button */}
            <ItemGrid xs={4}>
              <Button className={classes.button}
                onClick={this._onCloseModal.bind(this) }
              >
                {'Close'}
              </Button>
            </ItemGrid>
          </Grid>
        </ModalContent>
      </ReactModal>
    );
  }

  // change the name of an existing Sport from the Edit Team Modal
  editSport() {
    // the unedited sport info
    const sport = this.state.sport;
    // the new sport info
    var editedSport = [];
    // the new sport name
    const newSportName = this.state.sportName;
    // get the previous name of the Sport
    var oldSportName = sport[0];
    // if the old sport name is an object, retrieve the image and the name
    if (typeof oldSportName === 'object') {
      editedSport[0] = {key: oldSportName.key, value: newSportName};
      oldSportName = oldSportName.value;
    }
    // otherwise set the new sport object's name
    else {
      editedSport[0] = newSportName;
    }

    // retrieve the sports state
    var sports = this.state.sports;
    // grab rosters and schedules
    var rosters = this.state.rosters;
    var schedules = this.state.schedules;

    // if the names are not the same, all the hashes need to be changed
    if (oldSportName !== newSportName) {
      for (var d = 1; d < sport.length; ++d) {
        let oldHash = sport[d].key;
        let division = sport[d].value;
        let newHash = this.hashGeneration(newSportName + division);
        // iterate through Rosters
        for (var r = 0; r < rosters.length; ++r) {
          let roster = rosters[r];
          // if it belongs to one of the changed Divisions, change the hash
          if (roster.key === oldHash) {
            roster.key = newHash;
            rosters[r] = roster;
          }
        }
        // iterate through Schedules
        for (var s = 0; s < schedules.length; ++s) {
          let schedule = schedules[s];
          // if it belongs to one of the changed Divisions, change the hash
          if (schedule.key === oldHash) {
            schedule.key = newHash;
            schedules[s] = schedule;
          }
        }
      }
    } // end of sport name comparison if statement
    // check and add old and new divisions - varsity
    if (this.state.checkVarsity || this.state.sportInfo.varsity) {
      editedSport.push({key: this.hashGeneration(newSportName + 'Varsity'),
        value: 'Varsity'});
    }
    // check jv
    if (this.state.checkJV || this.state.sportInfo.jv) {
      editedSport.push({key: this.hashGeneration(newSportName + 'JV'),
        value: 'JV'});
    }
    // check and push freshman
    if (this.state.checkFresh || this.state.sportInfo.freshman) {
      editedSport.push({key: this.hashGeneration(newSportName + 'Freshman'),
        value: 'Freshman'});
    }
    // check custom
    if (this.state.checkCustom || this.state.sportInfo.custom) {
      // check and add first custom option
      if (this.state.customFirst !== '' && this.state.customFirst) {
        editedSport.push({
          key: this.hashGeneration(newSportName + this.state.customFirst),
          value: this.state.customFirst});
      }
      // check and add second custom option
      if (this.state.customSecond !== '' && this.state.customSecond) {
        editedSport.push({
          key: this.hashGeneration(newSportName + this.state.customSecond),
          value: this.state.customSecond});
      }
    }

    // get the index where the currently edited sport is located
    const index = this.findArrIndex(oldSportName);
    // change the sport at the found index
    sports[index] = editedSport;
    // set state and reset modal values
    this.setState({sports: sports, rosters: rosters, schedules: schedules,
      customFirst: '', customSecond: '', checkVarsity: false, checkJV: false,
      checkFresh: false, checkCustom: false, sportName: ''});
    // edit season and reload
    this._onEditSeason();
  }

  // given a string, find it as the name of a Sport and return its location
  findArrIndex(sport) {
    let sports = this.state.sports;
    if (!Array.isArray(sports))
    {
      return -1;
    }
    for (let i = 0; i < sports.length; ++i)
    {
      if (sports[i][0] === sport) {
        return i;
      }

      if (sports[i][0].value === sport) {
        return i;
      }
    }
    return -1;
  }

  // attach an image to a Sport
  // Images are stored in the first entry of a Sport array
  // in a key-value pair with the Name of the sport
  addImage(image) {
    let sport = this.state.sportName;
    let index = this.findArrIndex(sport);
    let sports = this.state.sports;
    let obj = {key: image, value: sport};
    sports[index][0] = obj;
    this.setState({sports: sports, sportBg: image});
    this._onEditSeason();
  }

  // find the image attached to a Sport, if it exists
  findImage() {
    let index = this.findArrIndex(this.state.sportName);
    if (index < 0) {
      return null;
    }
    let sports = this.state.sports;
    sports = sports[index][0];
    if (typeof sports === 'string') {
      return null;
    }
    return sports.key;
  }

  /*** SEASON FUNCTIONS ***/

  // the modal that enables adding a new Team to a Season
  addSeasonModal() {
    // import styles
    const { classes } = this.props;
    // the actual modal
    return (
      this.state.seasonModal &&
      <ReactModal isOpen={this.state.seasonModal}
        onRequestClose={this._closeSeasonModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={'Add Season'}
        ariaHideApp={false}
        style={teamModalStyles}
        overflow={'auto'}
      > {/* end of React Modal opening tag */}
        <ModalHeader>
          {'Add Season'}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            {/* Input field for the name of the Sport */}
            <ItemGrid xs={5}>
              <span className={classes.modalText}>
                Select Season:
              </span>
            </ItemGrid>
            <ItemGrid xs={5}>
              <Select
                id='sports'
                value={this.state.seasonName}
                onChange={(e)=>this.setState({seasonName: e.target.value})}
              >
                <MenuItem value={"Fall"}>
                  Fall
                </MenuItem>
                <MenuItem value={"Winter"}>
                  Winter
                </MenuItem>
                <MenuItem value={"Spring"}>
                  Spring
                </MenuItem>
              </Select>
            </ItemGrid>
            <ItemGrid xs={2} />
            <ItemGrid xs={4}>
              <Button className={classes.button}
                onClick={(e) => {this._onCreateNewSeason(this.state.seasonName)} }
              >
                {'Add'}
              </Button>
            </ItemGrid>
            <ItemGrid xs={4}>
              <Button className={classes.button}
                onClick={this._closeSeasonModal.bind(this) }
              >
                {'Close'}
              </Button>
            </ItemGrid>
          </Grid>
        </ModalContent>
      </ReactModal>
    );
  }

  // show the Add Season modal
  _ShowSeasonModal () {
    this.setState({
      seasonModal: true,
    })
  }

  // Close Add Season modal
  _closeSeasonModal () {
    this.setState({ seasonModal: false });
  }

  /*** ROSTERS FUNCTIONS ***/

  // add Roster object to the Rosters state
  addToRosters() {
    const { allSeason } = this.props;
    // retrieve current season
    const curSeason = allSeason[this.state.seasonTabs];
    var roster = this.state.roster;
    roster.key = this.state.hash;
    var rosters = this.state.rosters;
    rosters.push(roster);
    // reset roster values for modal and update Rosters array
    this.setState({roster: {key: '', name: '', number: '', height: '',
      weight: '', grade: '', position: ''},
      rosters: rosters,
    });
    // update current season
    this.props.editSeason(curSeason.id, {
      title: curSeason.title,
      sports: curSeason.sports,
      rosters: this.state.rosters,
      schedules: curSeason.schedules || [],
      id: curSeason.id,
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // prints the Roster of a given Team
  printRosters() {
    // get the hash for the current sport/division
    const hash = this.state.hash;
    // get which Season the sport is in
    const index = this.state.seasonTabs;
    // retrieve all season data
    const { allSeason, classes } = this.props;
    // select only the current season
    const season = allSeason[index];
    // if there's no rosters, return
    if (!season.hasOwnProperty('rosters')) {
      return (
        <TableRow className={classes.row}>
          No rosters have been added for this team.
        </TableRow>
      );
    }
    // get the rosters from that season
    const rosters = season.rosters;
    // otherwise, bind functions and map to a TableRow
    // only print if the hash matches
    return (
      rosters.map((roster, id) =>
        hash === roster.key ?
        <TableRow className={classes.row}>
          <Grid container>
            {/* roster player's number */}
            <ItemGrid xs={1}>
              {roster.number}
            </ItemGrid>
            {/* player name */}
            <ItemGrid xs={3}>
              {roster.name}
            </ItemGrid>
            {/* player position */}
            <ItemGrid xs={3}>
              {roster.position}
            </ItemGrid>
            {/* player's grade */}
            <ItemGrid xs={1}>
              {roster.grade}
            </ItemGrid>
            {/* player height */}
            <ItemGrid xs={1}>
              {roster.height}
            </ItemGrid>
            {/* player weight */}
            <ItemGrid xs={1}>
              {roster.weight}
            </ItemGrid>
            {/* Button that allows Editing a Roster */}
            <ItemGrid xs={1}>
              <Button className={classes.button}
                onClick={()=> this.initEditRoster(id, roster)}
              >
                EDIT
              </Button>
            </ItemGrid>
          </Grid>
        </TableRow>
        : null
      )
    );
  }

  // Add/Edit a Roster modal
  addRosterModal() {
    // import styles
    const { classes } = this.props;
    // the actual modal
    return (
      this.state.showModal &&
      <ReactModal isOpen={this.state.showModal}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Roster' : 'Add Roster'}
        ariaHideApp={false}
        style={teamModalStyles}
        overflow={'auto'}
      > {/* end of React Modal opening tag */}
        <ModalHeader>
          <Grid container>
            {this.state.isEditing ? 'Edit Roster' : 'Add Roster'}
          </Grid>
        </ModalHeader>
        {/* modal content */}
        <ModalContent>
          <Grid container>
            {/* Player Number text field */}
            <ItemGrid xs={5}>
              <TextField
                id='rosterNumber'
                label='Player Number'
                value={this.state.roster.number}
                onChange={(e)=> {
                  let roster = this.state.roster;
                  roster.number = e.target.value;
                  this.setState({roster: roster})}
                }
                inputProps={{maxLength: 3}}
              />
            </ItemGrid>
            {/* Player Position text field */}
            <ItemGrid xs={6}>
              <TextField
                id='rosterPosition'
                label='Player Position'
                value={this.state.roster.position}
                onChange={(e)=> {
                  let roster = this.state.roster;
                  roster.position = e.target.value;
                  this.setState({roster: roster})}
                }
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
            {/* Player Name text field */}
            <ItemGrid xs={5}>
              <TextField
                id='rosterName'
                label='Player Name'
                value={this.state.roster.name}
                onChange={(e)=> {
                  let roster = this.state.roster;
                  roster.name = e.target.value;
                  this.setState({roster: roster})}
                }
                inputProps={{maxLength: 50}}
              />
            </ItemGrid>
            {/* Player Grade text field */}
            <ItemGrid xs={6}>
              <TextField
                id='rosterGrade'
                label='Player Grade'
                value={this.state.roster.grade}
                onChange={(e)=> {
                  let roster = this.state.roster;
                  roster.grade = e.target.value;
                  this.setState({roster: roster})}
                }
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
            {/* Player Height text field */}
            <ItemGrid xs={5}>
              <TextField
                id='rosterHeight'
                label='Player Height'
                value={this.state.roster.height}
                onChange={(e)=> {
                  let roster = this.state.roster;
                  roster.height = e.target.value;
                  this.setState({roster: roster})}
                }
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
            {/* Player Weight text field */}
            <ItemGrid xs={6}>
              <TextField
                id='rosterWeight'
                label='Player Weight'
                value={this.state.roster.weight}
                onChange={(e)=> {
                  let roster = this.state.roster;
                  roster.weight = e.target.value;
                  this.setState({roster: roster})}
                }
                inputProps={{maxLength: 12}}
              />
            </ItemGrid>
          </Grid>
          <Grid container>
            <ItemGrid xs={3}>
            {/* if Editing, show Delete button */}
              { this.state.isEditing === true ?
                <Button className={classes.button}
                  onClick={() => this.deleteRoster() }
                >
                  {'Delete'}
                </Button>
                : null
              }
            </ItemGrid>
            <ItemGrid xs={9}>
              {/* show Edit button if Editing, Add button if Adding */}
              { this.state.isEditing === true ?
                <Button className={classes.button}
                  onClick={() => this.editRoster() }
                >
                  {'Edit'}
                </Button>
                :
                <Button className={classes.button}
                  onClick={() => this.addToRosters() }
                >
                  {'Add'}
                </Button>
              }
              {/* Close button */}
              <Button className={classes.button}
                onClick={this._onCloseModal.bind(this) }
              >
                {'Close'}
              </Button>
            </ItemGrid>
          </Grid>
        </ModalContent>
      </ReactModal>
    );
  }

  // set state so a Roster can be Edited
  initEditRoster(id, roster) {
    this.setState({id: id, roster: roster, showModal: true, isEditing: true});
  }

  // when Edit button is pressed on Edit Roster modal
  // sets state and edits Season
  editRoster() {
    var rosters = this.state.rosters;
    rosters[this.state.id] = this.state.roster;
    this.setState({roster: {key: '', name: '', number: '',
      height: '', weight: '', grade: '', position: ''},
      showModal: false,
      isEditing: false,
      rosters: rosters,
    });
    this._onEditSeason();
  }

  // delete a Roster from a Team
  deleteRoster() {
    var rosters = this.state.rosters;
    rosters.splice(this.state.id, 1);
    this.setState({rosters: rosters,
      roster: {key: '', name: '', number: '',
      height: '', weight: '', grade: '', position: ''},
      isEditing: false,
      showModal: false,
    });
    this._onEditSeason();
  }


  /*** SCHEDULES FUNCTIONS ***/

  // add a new Schedule to the Schedules array
  addToSchedules() {
    const { allSeason } = this.props;
    // get the current season from props
    const curSeason = allSeason[this.state.seasonTabs];
    // get schedule that is being added
    var schedule = this.state.schedule;
    // get current team hash
    schedule.key = this.state.hash;
    // format game date
    schedule.date = moment(schedule.date).format('MM/DD/YYYY, h:mm A');
    // get all existing schedules
    var schedules = this.state.schedules;
    // add the new schedules
    schedules.push(schedule);
    // reset the value of Schedule for the modal
    // and set the newly added Schedule to state
    this.setState({ schedule: {key: '', date: setDate(), win: '', homeAway: '',
      homeTeamScore: '', opponentTeamName: '', opponentTeamScore: '', tba: false},
      schedules: schedules,
    });
    // edit season
    this.props.editSeason(curSeason.id, {
      title: curSeason.title,
      sports: curSeason.sports,
      rosters: curSeason.rosters || [],
      schedules: schedules,
      id: curSeason.id,
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // prints the Schedule of a given Team
  printSchedules() {
    // retrieve hash
    const hash = this.state.hash;
    // get season index
    const index = this.state.seasonTabs;
    // get all seasons
    const { allSeason, classes } = this.props;
    // access only current season
    const season = allSeason[index];
    // get schedules
    // if there are no schedules, return
    if (!season.hasOwnProperty('schedules')) {
      return (
        <TableRow className={classes.row}>
          No schedules have been added for this team.
        </TableRow>
      );
    }
    // retrieve schedules
    const schedules = season.schedules;
    // otherwise, map and print
    return (
      schedules.map((schedule, id) =>
        hash === schedule.key ?
        <TableRow className={classes.row}>
          <Grid container>
            {/* Game date */}
            <ItemGrid xs={2}>
              {/* If time is TBA, print as such */}
              { schedule.tba ? moment(schedule.date).format('MM/DD/YYYY') + ', TBA' :
                moment(schedule.date).format('MM/DD/YYYY, h:mm A') }
            </ItemGrid>
            {/* Team being played against */}
            <ItemGrid xs={3}>
              {schedule.opponentTeamName}
            </ItemGrid>
            {/* Home or Away game */}
            <ItemGrid xs={2}>
              {schedule.homeAway}
            </ItemGrid>
            {/* Game Score - not printed if Win/Loss status has not been set */}
            { schedule.win !== '' ?
              <ItemGrid xs={1}>
                {schedule.homeTeamScore}-{schedule.opponentTeamScore}
              </ItemGrid>
              :
              <ItemGrid xs={1} />
            }
            {/* Win/Loss status - not printed if not set */}
            { schedule.win !=='' ?
              <ItemGrid xs={1}>
                {schedule.win}
              </ItemGrid>
              :
              <ItemGrid xs={1} />
            }
            {/* Edit Schedule buttons */}
            <ItemGrid xs={3}>
              <Button className={classes.button}
                onClick={()=>this.initEditSchedule(id, schedule)}
              >
                ADD SCORE
              </Button>
              {/* These do the exact same thing */}
              <Button className={classes.button}
                onClick={()=>this.initEditSchedule(id, schedule)}
              >
                EDIT
              </Button>
            </ItemGrid>
          </Grid>
        </TableRow>
        : null
      )
    );
  }

  // the modal that enables adding/editing a Schedule
  addScheduleModal() {
    // import styles
    const { classes } = this.props;
    // the actual modal
    return (
      this.state.showModal &&
      <ReactModal isOpen={this.state.showModal}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Schedule' : 'Add Schedule'}
        ariaHideApp={false}
        style={teamModalStyles}
        overflow={'auto'}
      > {/* end of React Modal opening tag */}
        <ModalHeader>
          {this.state.isEditing ? 'Edit Schedule' : 'Add Schedule'}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            {/* Pick Game Date
              Game Date and Time are stored in the same schedule.date object */}
            <ItemGrid xs={4}>
              <DatePicker
                label='Game Date'
                id='scheduleDate'
                autoOk={true}
                fullWidth
                value={this.state.schedule.date}
                /* get previous hour/minute from old Date
                  before setting the new one */
                onChange={(e) => {
                  let schedule = this.state.schedule;
                  let newDate = moment(e);
                  let prevDate = moment(this.state.schedule.date);
                  if (typeof prevDate === 'object') {
                    newDate.set('hour', prevDate.get('hour'));
                    newDate.set('minute', prevDate.get('minute'));
                  }
                  schedule.date = newDate;
                  this.setState({schedule: schedule});
                }}
              />
            </ItemGrid>
            {/* Schedule Game Time picker
                Disabled if game time is still to be announced
              */}
            <ItemGrid xs={4}>
              <TimePicker
                label='Game Time'
                id='scheduleTime'
                value={this.state.schedule.date}
                minutesStep={15}
                fullWidth
                disabled={this.state.schedule.tba}
                onChange={(e) => {
                  let schedule = this.state.schedule;
                  schedule.date = new Date(e);
                  this.setState({schedule: schedule});
                }}
              />
            </ItemGrid>
            {/* TBA Checkbox if a game's Time has not yet been determined */}
            <ItemGrid xs={4}>
              <div style={{flexDirection: 'row'}}>
                <span>
                  Time TBA?
                </span>
              <Checkbox
                checked={this.state.schedule.tba}
                onChange={(e) => {
                  let schedule = this.state.schedule;
                  schedule.tba = !schedule.tba;
                  this.setState({schedule: schedule});
                }}
                value="checked"
                color="primary"
              />
              </div>
            </ItemGrid>
            {/* Game Home/Away status */}
            <ItemGrid xs={4}>
              <TextField
                id='scheduleHomeAway'
                label='Home/Away'
                fullWidth
                value={this.state.schedule.homeAway}
                onChange={(e)=> {
                  let schedule = this.state.schedule;
                  schedule.homeAway = e.target.value;
                  this.setState({schedule: schedule})}
                }
                inputProps={{maxLength: 6}}
              />
            </ItemGrid>
            {/* Opponent Team Name */}
            <ItemGrid xs={8}>
              <TextField
                id='scheduleOpponentTeamName'
                label='Opponent Team'
                value={this.state.schedule.opponentTeamName}
                fullWidth
                onChange={(e)=> {
                  let schedule = this.state.schedule;
                  schedule.opponentTeamName = e.target.value;
                  this.setState({schedule: schedule})}
                }
                inputProps={{maxLength: 48}}
              />
            </ItemGrid>
            {/* Game Win/Loss status */}
            <ItemGrid xs={3}>
              <TextField
                id='scheduleWin'
                label='Win/Loss'
                value={this.state.schedule.win}
                fullWidth
                onChange={(e)=> {
                  let schedule = this.state.schedule;
                  schedule.win = e.target.value;
                  this.setState({schedule: schedule})}
                }
                inputProps={{maxLength: 6}}
              />
            </ItemGrid>
            <ItemGrid xs={1} />
            {/* Game Home Team Score */}
            <ItemGrid xs={3}>
              <TextField
                id='scheduleHomeTeamScore'
                label='Home Score'
                value={this.state.schedule.homeTeamScore}
                fullWidth
                onChange={(e)=> {
                  let schedule = this.state.schedule;
                  schedule.homeTeamScore = e.target.value;
                  this.setState({schedule: schedule})}
                }
                inputProps={{maxLength: 6}}
              />
            </ItemGrid>
            <ItemGrid xs={1} />
            {/* Game Opponent Team Score */}
            <ItemGrid xs={4}>
              <TextField
                id='scheduleOpponentTeamScore'
                label='Opponent Score'
                value={this.state.schedule.opponentTeamScore}
                fullWidth
                onChange={(e)=> {
                  let schedule = this.state.schedule;
                  schedule.opponentTeamScore = e.target.value;
                  this.setState({schedule: schedule})}
                }
                inputProps={{maxLength: 6}}
              />
            </ItemGrid>
            {/* if Editing and not Adding, show a Delete button */}
            <ItemGrid xs={3}>
              { this.state.isEditing === true ?
                <Button className={classes.button}
                  onClick={() => this.deleteSchedule() }
                >
                  {'Delete'}
                </Button>
                : null
              }
            </ItemGrid>
            <ItemGrid xs={9}>
              {/* Show either Add or Edit button */}
              { this.state.isEditing === false ?
                <Button className={classes.button}
                  onClick={() => this.addToSchedules() }
                >
                  {'Add'}
                </Button>
                :
                <Button className={classes.button}
                  onClick={() => this.editSchedule() }
                >
                  {'Edit'}
                </Button>
              }
              {/* Close button */}
              <Button className={classes.button}
                onClick={this._onCloseModal.bind(this) }
              >
                {'Close'}
              </Button>
            </ItemGrid>
          </Grid>
        </ModalContent>
      </ReactModal>
    );
  }

  // set state to enable editing a schedule in the modal
  initEditSchedule(id, schedule) {
    this.setState({id: id, schedule: schedule, showModal: true, isEditing: true});
  }

  // complete editing a schedule
  editSchedule() {
    // get all schedules
    var schedules = this.state.schedules;
    // get the current schedule
    var schedule = this.state.schedule;
    // format schedule date
    schedule.date = moment(schedule.date).format('MM/DD/YYYY, h:mm A');
    // set the old schedule to the edited schedule
    schedules[this.state.id] = schedule;
    // reset schedule and set schedules
    this.setState({ schedule: { key: '', date: setDate(), win: '',
      homeAway: '', homeTeamScore: '',
      opponentTeamName: '', opponentTeamScore: '', tba: false},
      showModal: false,
      isEditing: false,
      schedules: schedules,
    });
    this._onEditSeason();
  }

  // delete a Schedule from a Team
  deleteSchedule() {
    // retrieve schedules
    var schedules = this.state.schedules;
    // delete the singular schedule
    schedules.splice(this.state.id, 1);
    // reset schedule, set schedules
    this.setState({ schedule: { key: '', date: setDate(), win: '',
      homeAway: '', homeTeamScore: '',
      opponentTeamName: '', opponentTeamScore: '', tba: false},
      showModal: false,
      isEditing: false,
      schedules: schedules,
    });
    this._onEditSeason();
  }

  // Print Team - displays either Schedule, Roster, or Details tab
  printTeam() {
    const select = this.state.teamTabs;
    switch(select) {
      // print schedules on first tab
      case 0:
        return this.printSchedules();
      // print rosters on second tab
      case 1:
        return this.printRosters();
      // print other team functions on third tab
      case 2:
        // get styles
        const { classes } = this.props;
        return (
          <Grid container>
            <ItemGrid xs={3} />
            {/* Team Photo explanation */}
            <ItemGrid xs={9}>
              <div className={classes.headerText}>
                Team Photo - Same for All Divisions - 7:3 Aspect Ratio
              </div>
            </ItemGrid>
            <ItemGrid xs={4} />
            {/* Upload an Image for each Sport */}
            <ItemGrid xs={8}>
              <UploadButton
                storage="sportBg"
                style={{width: '280px', height: '120px'}}
                value={this.findImage()}
                onUploadComplete={(image) => this.addImage(image)}
              />
            </ItemGrid>
          </Grid>
        )
      // requisite default case
      default:
        return null;
    }
  }

  // print the top informational bar on the Roster and Schedule tabs
  printHeader() {
    const { classes } = this.props;
    // Roster header
    if (this.state.teamTabs === 1) {
      return (
        <Grid container>
          {/* header for roster number */}
          <ItemGrid xs={1}>
            <div className={classes.headerText}>
              #
            </div>
          </ItemGrid>
          {/* roster name */}
          <ItemGrid xs={3}>
            <div className={classes.headerText}>
              Name
            </div>
          </ItemGrid>
          {/* roster position */}
          <ItemGrid xs={3}>
            <div className={classes.headerText}>
              Position
            </div>
          </ItemGrid>
          {/* roster grade */}
          <ItemGrid xs={1}>
            <div className={classes.headerText}>
              Grade
            </div>
          </ItemGrid>
          {/* roster height */}
          <ItemGrid xs={1}>
            <div className={classes.headerText}>
              Height
            </div>
          </ItemGrid>
          {/* roster weight */}
          <ItemGrid xs={1}>
            <div className={classes.headerText}>
              Weight
            </div>
          </ItemGrid>
        </Grid>
      )
    }
    // Schedule header
    if (this.state.teamTabs === 0) {
      return (
        <Grid container>
          {/* schedule date */}
          <ItemGrid xs={2}>
            <div className={classes.headerText}>
              Game Date
            </div>
          </ItemGrid>
          {/* schedule opponent */}
          <ItemGrid xs={3}>
            <div className={classes.headerText}>
              Opponent Team Name
            </div>
          </ItemGrid>
          {/* schedule home/away */}
          <ItemGrid xs={2}>
            <div className={classes.headerText}>
              Home/Away
            </div>
          </ItemGrid>
          {/* schedule score */}
          <ItemGrid xs={1}>
            <div className={classes.headerText}>
              Score
            </div>
          </ItemGrid>
          {/* schedule win/loss */}
          <ItemGrid xs={1}>
            <div className={classes.headerText}>
              Win/Loss
            </div>
          </ItemGrid>
        </Grid>
      );
    }
    // no case needed for Details tab
  }

  // Season List Render function
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'season'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('season'))
    {
      return (
        <Redirect from={'season'} to={'dashboard'} key={'noTicket'} />
      );
    }

    // inherited Props
    // classes - styles
    // allSeason - all the different stored Seasons
    // isLoading - bool
    const { classes, allSeason, isLoading } = this.props;
    // start return statement

    var seasons = allSeason;
    // if loading in progress, show the loading spinnyboi
    if (isLoading) {
      return (
        <Table className={classes.table}>
          <TableBody>
            {isLoading &&
              <TableRow>
                <TableCell colSpan={6}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      );
    }

    // if loading is done, show the page
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        {/* show either a Home icon or a Back button in the top left */}
        { this.state.editingTeam ?
        <Grid container>
          <ItemGrid xs={5}>
            <IconButton tooltip="Return to Team Select"
              onClick={()=>this.setState({editingTeam: false, teamTabs: 0})}
            >
              <BackIcon />
            </IconButton>
            Return to Team Management
          </ItemGrid>
          {/* Print which Team and Division are currently being edited */}
          <ItemGrid xs={5}>
            <div className={classes.headerText}>
              Editing {" "}
              {this.state.sportDivision} {" "}
              {this.state.sportName}
            </div>
          </ItemGrid>
        </Grid>
        :
        <div>
          {/* It's a button but it doesn't -do- anything,
           just there to position the top of the table correctly */}
          <IconButton tooltip="Home Page"
            disabled={true}
          >
            <HomeIcon />
          </IconButton>
          Team Management
        </div>
        }
        {/* Table displays every team and division,
          or the details of a single team and division */}
        <Table className={classes.table}>
        { this.state.editingTeam === false ?
          <TableBody>
            <Grid container>
              <ItemGrid xs={2}/>
              <ItemGrid xs={7}>
                <Tabs value={this.state.seasonTabs}
                  onChange={this.changeSeasonTab}>
                  {/* map season names to Tab */}
                  { seasons.map((n, id) => {
                    return (
                      <Tab label={n.title} />
                    );
                  })}
                </Tabs>
              </ItemGrid>
              {/* Add Team button to right of Tabs */}
              <ItemGrid xs={2}>
                { allSeason.length > 0 ?
                <Button className={classes.smallButton}
                  onClick={this._ShowAddModal.bind(this)}>
                  ADD TEAM
                </Button>
                : null }
                {
                  this.state.isEditing ?
                  this.editTeamModal()
                  :
                  this.addTeamModal()
                }
                {/* Add Season button */}
                { allSeason.length < 3 ?
                  <Button className={classes.smallButton}
                    onClick={()=>this.setState({seasonModal: true})}>
                    ADD SEASON
                  </Button>
                : null }
                { this.addSeasonModal() }
              </ItemGrid>
            </Grid>
            {/* print Sports and Divisions depending on current Tab */}
            { this.printSports(seasons[this.state.seasonTabs]) }
          </TableBody> /* end of Season Tabs */
          :
          <TableBody>
            <Grid container>
              <ItemGrid xs={2}/>
              <ItemGrid xs={7}>
                {/* Schedule, Roster, and Details tabs */}
                <Tabs value={this.state.teamTabs} onChange={this.changeTeamTab}>
                  <Tab label={'Schedule'} />
                  <Tab label={'Roster'} />
                  <Tab label={'Details'} />
                </Tabs>
              </ItemGrid>
              <ItemGrid xs={2}>
                {/* Add Schedule button for Schedule tab */}
                {this.state.teamTabs === 0 ?
                  <div>
                    <Button className={classes.smallButton}
                      onClick={this._ShowAddModal.bind(this)}>
                      ADD SCHEDULE
                    </Button>
                    { this.addScheduleModal() }
                  </div>
                  : null
                }
                {/* Add Roster button for Roster tab */}
                {this.state.teamTabs === 1 ?
                  <div>
                    <Button className={classes.smallButton}
                      onClick={this._ShowAddModal.bind(this)}>
                      ADD ROSTER
                    </Button>
                    { this.addRosterModal() }
                  </div>
                  : null
                }
              </ItemGrid>
            </Grid>
            {/* print the appropriate Header for Schedule or Roster */}
            { this.printHeader() }
            {/* print Schedule, Roster, or Details */}
            { this.printTeam() }
          </TableBody>
        }
        </Table>
      </MuiPickersUtilsProvider>
    ); /* end of Return */
  } /* end of Render */
} /* end of SeasonList */

// required proptypes
SeasonList.propTypes = {
  classes: PropTypes.object.isRequired,
};

// map allSeason and isLoading to reducers
const mapStateToProps = state => ({
  allSeason: state.seasonReducer.season,
  isLoading: state.seasonReducer.isLoading,
  user: state.authReducer.user,
  loggedIn: state.authReducer.loggedIn,
});

// get from Actions file
const mapDispatchToProps = {
    loadSeason,
    createNewSeason,
    editSeason,
    deleteSeason
};

// Final Export
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SeasonList));
